/**
 * Resolves the Chart.js active element for a hovered summary-table cell.
 *
 * The summary table and the chart are indexed differently: a row maps to a
 * dataset by label, but a column index only lines up with a data point on
 * reports whose table columns are periods. On reports whose columns are
 * metrics the index can run past the end of the series, and Chart.js throws
 * while styling an element that does not exist. Returning an empty selection
 * leaves the chart unhighlighted, which is the correct no-op.
 *
 * @param {Array} datasets - chart.data.datasets
 * @param {string|null} label - hovered row label
 * @param {number|null} colIdx - hovered column index
 * @returns {Array<{datasetIndex: number, index: number}>}
 */
const isMissing = value => value === null || value === undefined

export function activeElementsFor(datasets, label, colIdx) {
  if (isMissing(label) || isMissing(colIdx)) return []

  const list = Array.isArray(datasets) ? datasets : []
  const datasetIndex = list.findIndex(ds => ds.label === label)
  if (datasetIndex < 0) return []

  const pointCount = list[datasetIndex]?.data?.length ?? 0
  if (colIdx < 0 || colIdx >= pointCount) return []

  return [{ datasetIndex, index: colIdx }]
}
